import React from "react";
import {Chip, IconButton, Tooltip} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {CampaignLinks} from './CampaignLinks';

dayjs.extend(utc);

export default function Cohort({cohort, children, disableCurrentSize, cohortsSizeUpdatedAt, campaignLinks}) {
    const sizeUpdatedLabel = cohortsSizeUpdatedAt != null
        ? `Обновлено ${dayjs.unix(cohortsSizeUpdatedAt).utcOffset(180).format('YYYY-MM-DD HH:mm:ss')} (UTC+03:00)`
        : null;

    return (
        <div className="audience-item">
            <div className="audience-item__inline">{children}</div>
            <div className="audience-item__inline">
             <Chip size={"small"} label={cohort.active ? "active": "inactive"} color={cohort.active ? "success" : "error"}/>
            </div>
            <div className="audience-item__inline">
                <Chip label={`Weight: ${cohort.weight}`}/>
            </div>
            <div className="audience-item__inline">
                <Chip label={cohort.limit === -1? "No limit": "Size limit: " + cohort.limit}/>
            </div>
            {(cohort.hasOwnProperty('userGroups') && cohort.userGroups!= null && cohort.userGroups.length>0 ) &&
            <div className="audience-item__inline">
                <Chip label={"User group: " + cohort.userGroups.join(', ')}/>
            </div>}

            {!disableCurrentSize && <div className="audience-item__inline__right">
                <Chip size={"small"}
                      sx={{'& .MuiChip-label': {display: 'inline-flex', alignItems: 'center', gap: 0.5}}}
                      label={<>
                          Current size: {cohort.size}
                          {sizeUpdatedLabel && <Tooltip title={sizeUpdatedLabel} arrow>
                              <IconButton size="small" aria-label={sizeUpdatedLabel} sx={{p: 0}}>
                                  <InfoOutlinedIcon sx={{fontSize: 16}}/>
                              </IconButton>
                          </Tooltip>}
                      </>}/>
            </div>}

            <div className={"audience-item__connected"}>
                <div className="audience-item__inline">Connected campaigns:</div>
                {campaignLinks === undefined ?
                    <div className="audience-item__inline" style={{display: 'block'}}>
                        {cohort.campaigns?.length > 0
                            ? cohort.campaigns.map(id => <Chip key={id} size="small" label={id}/>)
                            : <Chip size="small" label="No"/>}
                    </div>
                    : <CampaignLinks links={campaignLinks}/>}
            </div>


        </div>
    )

}
